import SidebarCollapsable from './sidebar-collapsable'

export const AmuiSidebarCollapsable = SidebarCollapsable

export default Vue => Vue.component(SidebarCollapsable.name, SidebarCollapsable)
